module.exports = "<ag-grid-angular #agGrid1\r\n             class=\"height-45-vh\"\r\n             [gridOptions]=\"gridAddresses\"\r\n             (cellDoubleClicked)=\"OnCellDoubleClicked($event)\"\r\n>\r\n</ag-grid-angular>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/A2-utils/previous-address/previous-address.component.html
// module id = 2348
// module chunks = 66